export const LOADING_LEVEL = "LOADING_LEVEL";
export const SAVE_LOADING_LEVEL = "SAVE_LOADING_LEVEL";
export const GET_LEVEL = "GET_LEVEL";
export const FORM_FAIL = "FORM_FAIL";
export const LEVEL_FAIL = "LEVEL_FAIL";
export const LOADING_LEVEL_BY_ID = "LOADING_LEVEL_BY_ID";
export const GET_LEVEL_BY_ID = "GET_LEVEL_BY_ID";

